import { Suspense, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import './home.css'


import Experience from '../../three/Experience'
import Nav from '../Nav/Nav'
import Sidebar from '../Sidebar/Sidebar'
import Intro from '../Popups/Intro'

const Home = ({sidebarIsOpen, setSidebarIsOpen, setEnableControls, enableControls}) =>
{
    // State
    // const [showIntro, setShowIntro] = useState(false)

    // Close sidebar
    useEffect(()=>{
        setSidebarIsOpen(false)
    },[])

    return(
        <div className="home">
            <Helmet>
                <title>Antino Kila - Frontend Developer Portfolio</title>
                <meta name='description' content='This is Antino Kila, a creative frontend developer based in United Kingdom.' />
            </Helmet>

            <Suspense fallback={null}>
                <div className="canvas">
                    <Experience enableControls={enableControls} setEnableControls={setEnableControls} />
                </div>
            </Suspense>

            <Nav sidebarIsOpen={sidebarIsOpen} setSidebarIsOpen={setSidebarIsOpen} />
            {sidebarIsOpen? <Sidebar /> : ""}

            {/* {showIntro && <Intro setShowIntro={setShowIntro} />} */}

            {/* {enableControls && !hideMessage?  */}
            {/* <div className="home-info">
                <div>
                    <RiDragMoveFill className='home-info-icon' />
                </div>
                <small>Drag the scene</small>
            </div> */}
            {/* : ""} */}

            {/* <Footer /> */}
        </div>
    )
}

export default Home